import { render, staticRenderFns } from "./ExpandIcon.vue?vue&type=template&id=8a2f2368&"
import script from "./ExpandIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports